/* eslint-disable jsx-a11y/media-has-caption */
import PropTypes from 'prop-types';

import { useDropzone } from 'react-dropzone';
import {useState} from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Box} from '@mui/material';
//
// // import Image from '../Image';
// import { setConstantValue } from 'typescript';


import RejectionFiles from './RejectionFiles';
import BlockContent from './BlockContent';
// import MultiFilePreviewAudio from './MultiFilePreviewAudio';


// ----------------------------------------------------------------------

const DropZoneStyle = styled('div')(({ theme }) => ({
  outline: 'none',
  overflow: 'hidden',
  position: 'relative',
  padding: theme.spacing(5, 1),
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create('padding'),
  backgroundColor: theme.palette.background.neutral,
  border: `1px dashed ${theme.palette.grey[500_32]}`,
  '&:hover': { opacity: 0.72, cursor: 'pointer' },
}));

// ----------------------------------------------------------------------

UploadAudio1.propTypes = {
  error: PropTypes.bool,
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onRemove: PropTypes.func,
  onRemoveAll: PropTypes.func,
  showPreview: PropTypes.bool,
  helperText: PropTypes.node,
  sx: PropTypes.object,
};

export default function UploadAudio1({ error = false,  

  file,
 helperText, sx, ...other }) {
  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple: false,
    ...other,
  });
  const [audioFile, setAudio] = useState([]);

  // const removeFile = file => () => {

  //   const newFiles = [...file]
  //   newFiles.splice(newFiles.indexOf(file), 1)


  //  /// setMyFiles(newFiles)
  // }

  const onRemoves = (file) => {

    setAudio((audioFile) => audioFile.filter((_, i) => i !== file));
    //  const prev = [...audio];
    // prev.splice(file[0].preview);
    //   setAudio(prev);
  }

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <DropZoneStyle
        {...getRootProps()}
        sx={{
          ...(isDragActive && { opacity: 0.72 }),
          ...((isDragReject || error) && {
            color: 'error.main',
            borderColor: 'error.light',
            bgcolor: 'error.lighter',
          }),
          ...(file && {
            padding: '12% 0',
          }),
        }}
      >
        <input {...getInputProps()} />

        <BlockContent />        
 
        
      </DropZoneStyle>


      
      {/* const files = myFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes{" "}
      <button onClick={removeFile(file)}>Remove File</button>
    </li>
  )) */}
 
      {
       
      
      file &&
      

     
      

 <>

 {/* <button type="button" onClick={() => other.isEdit ? removeAudio(file): URL.createObjectURL(new Blob(removeAudio(file)))}>X</button> */}
 <button type="button" onClick={() => onRemoves(file)}>X</button>

 {/* <IconButton edge="end" size="small" onClick={() => onRemove(file)} /> */}

 <audio style={{ padding: 10 }} width="300" height="200" id ="fileclss" controls>
  <source   src={other.isEdit ? file : URL.createObjectURL(new Blob(file))} />


        </audio></>  
            

      
      }
      {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}
      {/* <MultiFilePreviewAudio files={file} showPreview={showPreview} onRemove={onRemove} onRemoveAll={onRemoveAll} /> */}
      {helperText && helperText}
    </Box>
  );
}
